module.exports = __webpack_public_path__ + "img/opinionlab-2013-release.6b907f1e.jpg";